import { render, staticRenderFns } from "./differenceShareProfit.vue?vue&type=template&id=5d39c994&"
import script from "./differenceShareProfit.vue?vue&type=script&lang=js&"
export * from "./differenceShareProfit.vue?vue&type=script&lang=js&"
import style0 from "./differenceShareProfit.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports